const status = state => state.status
const inOutDates = state => state.inOutDates
const transferItems = state => state.transferItems
const lengthsOfTransferResourceIds = state => state.lengthsOfTransferResourceIds
const splitedTransferResourceIds = state => state.splitedTransferResourceIds
const transferResourceIdsForCurrentPage = state => state.splitedTransferResourceIds[state.pageObj.currentPage - 1]
const checkboxModels = state => state.checkboxModels
const pageObj = state => state.pageObj
export default {
    status,
    inOutDates,
    transferItems,
    lengthsOfTransferResourceIds,
    splitedTransferResourceIds,
    transferResourceIdsForCurrentPage,
    checkboxModels,
    pageObj
}
